import ImageView from "../Shared/BlockEditor/Views/Image.vue"
import ImageLeftView from "../Shared/BlockEditor/Views/ImageLeft.vue"
import TextView from "../Shared/BlockEditor/Views/Text.vue"
import FileView from "../Shared/BlockEditor/Views/File.vue"
import TwoImagesView from "../Shared/BlockEditor/Views/TwoImages.vue"
import ThreeImagesView from "../Shared/BlockEditor/Views/ThreeImages.vue"
export default {
  components: {
    ImageView,
    TextView,
    ImageLeftView,
    FileView,
    TwoImagesView,
    ThreeImagesView
  }
}